import './App.css';
import AppCommercant from './commerçant/AppCommercant';


import  ThemeProvider  from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import PrivateRoute from './router/PrivateRoute';


function App() {
  return (    
        <ThemeProvider>
      <AuthProvider>
        <LanguageProvider>
    <div className="App">
      <PrivateRoute>
      <AppCommercant/>
      </PrivateRoute>
    </div>
            </LanguageProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
